module.exports = "/_next/static/images/choose-source-111d3f6fcb2f85034c990227974608e5.png";